<template>
	<div class="comHeader">
		<div class="header-container">
			<a href="/" class="header-left">内容管理系统</a>
			<a href="javascript:void(0)" class="header-right" @click="headerList($event)">
				<div class="header-img" style="background: url(../../../static/favicon.ico) no-repeat center center;background-size:100% 100% ;"></div>
				<div class="user-name">{{userName}}</div>
				<div class="header-list">
					<div class="header-trangle"></div>
					<ul>
						<li>
							<a href="/editPassword">修改密码</a>
						</li>
						<li>
							<a href="javascript:void(0)" @click="loginOut">退出</a>
						</li>
					</ul>
				</div>
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'comHeader',
		data() {
			return {
				userName: "何必能"
			}
		},
		created: function() {
			this.userName = this.getLocalUser.nickname
		},
		mounted: function() {
			$("html").on("click", function() {
				$(".header-list").hide()
			})
		},
		methods: {
			headerList: function($event) {
				$event.stopPropagation();
				let toggle = $($event.currentTarget);
				toggle.find(".header-list").show()
			},
			loginOut: function() {
				localStorage.removeItem("user")
				location.href = "/login"
			}
		}

	}
</script>

<style scoped="">
	.comHeader {
		width: 100%;
		height: 55px;
		background: #292C34;
	}
	
	.header-left {
		float: left;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 55px;
		display: block;
	}
	
	.header-left:hover,
	.header-left:focus {
		color: #FFFFFF;
	}
	
	.header-right {
		float: right;
		display: block;
		padding-top: 10px;
		position: relative;
	}
	
	.header-img {
		width: 31px;
		height: 31px;
		border-radius: 100%;
		overflow: hidden;
		display: table;
		vertical-align: middle;
		float: left;
	}
	
	.user-name {
		float: left;
		font-size: 12px;
		color: #fff;
		line-height: 31px;
		margin-left: 10px;
	}
	
	.header-container {
		padding: 0 37px;
	}
	
	.header-list {
		position: absolute;
		top: 55px;
		right: 0;
		width: 81px;
		background: #fff;
		box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
		-ms-box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
		-webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
		-moz-box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
		z-index: 1000;
		display: none;
	}
	
	.header-list a {
		display: block;
		font-size: 14px;
		line-height: 30px;
		width: 100%;
		text-align: center;
		color: #292C34;
	}
	
	.header-list a:hover {
		background: #d3d3d3;
	}
	
	.header-trangle {
		width: 0px;
		height: 0px;
		border: 10px solid transparent;
		border-bottom-color: #fff;
		position: absolute;
		left: 30px;
		top: -20px;
		/*透明 透明  灰*/
	}
</style>


// WEBPACK FOOTER //
// src/components/comHtml/comHeader.vue